import { render, staticRenderFns } from "./DayStatisticsWidget.vue?vue&type=template&id=4d85c5dc&"
import script from "./DayStatisticsWidget.vue?vue&type=script&lang=js&"
export * from "./DayStatisticsWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QSelect,QSeparator} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QSelect,QSeparator})
